
<div class="ed-hero">
  <div class="container">
    <div class="ed-head">
      <a class="ed-logo-frame" [href]="context.links.promo_index|userToken">
        <svg class="ed-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4657 687">
          <path class="ed-surface"
                d="M1390.64,467v26.57H1185.16V203h199.25v26.57H1215.87V332.89h116.58V359H1215.87V467Zm72.22-264h30.72V467H1656.3v26.57H1462.86Zm244.5,0h30.71V493.54h-30.71Zm181.81,26.57H1787.05V203h235v26.57H1919.89v264h-30.72ZM2276.46,467v26.57H2071V203h199.26v26.57H2101.7V332.89h116.58V359H2101.7V467Zm386-118.72c0-85.93,66.42-149.44,156.5-149.44s156.5,63.1,156.5,149.44S2909.08,497.69,2819,497.69,2662.5,434.18,2662.5,348.25Zm258.62,0c0-59.36-43.59-102.12-102.12-102.12s-102.12,42.76-102.12,102.12S2760.47,450.37,2819,450.37,2921.12,407.61,2921.12,348.25Zm362,145.29-.42-192.61-95.47,159.4h-24.08l-95.48-156.91V493.54h-51.47V203h44.42L3176,395.57,3289.32,203h44.42l.41,290.58ZM3723.51,203h54V493.54h-54Zm390.62,0V493.54h-44.42L3909.48,296.78V493.54h-53.55V203h44.42l160.23,196.76V203Zm53.54,259.86,18.68-41.93c23.25,18.69,60.19,32,95.9,32,45.24,0,64.34-16.19,64.34-37.78,0-62.68-172.69-21.58-172.69-129.51,0-46.91,37.36-86.76,117.06-86.76,34.87,0,71.4,9.13,96.72,25.73l-17,41.93c-26.15-15.36-54.79-22.83-80.11-22.83-44.83,0-63.1,17.44-63.1,39.44,0,61.85,172.27,21.58,172.27,128.27,0,46.49-37.77,86.34-117.47,86.34C4237,497.69,4191.75,483.58,4167.67,462.82ZM3555.4,203h-53.14L3371.5,493.54h55.63l10-23.53H3437l4.26-9.65,14.51-34.08L3474,384l54.38-127,42.84,99.3h.21L3581.53,380l1.68,3.91h0l18.09,42.82,28.85,66.77h56.46Zm-1088,0h-127v217.9h54V248.62h70.57c64.76,0,106.68,39.44,106.68,99.63s-41.92,99.63-106.68,99.63H2421.1v45.66h46.31c94.23,0,158.57-58.11,158.57-145.29S2561.64,203,2467.41,203Z"></path>
          <path class="ed-surface"
                d="M3.39,0V687h925V0ZM158.08,309.43H332.34v68.08H158.08Zm276.39,238.3H158.08V479.64H434.47Zm136.17,0V479.64c75.45,0,136.83-61.47,136.83-136.92S646.09,207.3,570.64,207.3H502.56V411.56H434.47V207.3H158.25V139.21H570.64c112.25,0,203.58,91.25,203.58,203.51S682.89,547.73,570.64,547.73Z"></path>
        </svg>
      </a>

      <div class="ed-verified">
        <app-icon>verified_user</app-icon>
        <a class="e--link-plain" [href]="context.links.promo_index|userToken" target="_blank" i18n>Verifiziert durch ELITEDOMAINS</a>
      </div>
    </div>
    <h1 i18n>
      Die Domain <span>{{ context.config.display_name }}</span> steht zum Verkauf
    </h1>

    <div class="grid">
      <div class="cell l6">
        <div class="ed-promo">
          <p>
            <ng-container i18n>Mit einer guten Domain generieren Sie <strong>mehr Besucher</strong> und damit ist Ihr
              Projekt <strong>erfolgreicher</strong> oder Ihre Firma generiert <strong>mehr Umsatz</strong>.
            </ng-container><br>
            <br>
            <ng-container i18n>Bei Interesse füllen Sie einfach das Formular mit Preisvorschlag aus! Fügen Sie gerne
              auch eine individuelle Nachricht hinzu. Der Domain-Inhaber wird sich schnell mit Ihnen in Verbindung
              setzen und Ihnen ein unverbindliches Angebot machen.
            </ng-container><br>
            <br>
            <ng-container i18n>Die Vorteile einer Premium-Domain im Überblick:</ng-container><br>
          </p>

          <ul class="ed-listed-usps">
            <li>
              <app-icon>check_circle</app-icon>
              <ng-container i18n>Einzigartigkeit</ng-container>
            </li>
            <li>
              <app-icon>check_circle</app-icon>
              <ng-container i18n>Höhere Sichtbarkeit</ng-container>
            </li>
            <li>
              <app-icon>check_circle</app-icon>
              <ng-container i18n>Bessere Merkbarkeit</ng-container>
            </li>
            <li>
              <app-icon>check_circle</app-icon>
              <ng-container i18n>Mehr Kundenvertrauen</ng-container>
            </li>
            <li>
              <app-icon>check_circle</app-icon>
              <ng-container i18n>Niedrigere Marketingkosten</ng-container>
            </li>
          </ul>

          @if (context.config.price) {
            <div class="ed-note">
              <app-icon>paid</app-icon>
              <div class="ed-content">
                <h2>
                  <ng-container i18n>Ungefähre Preisvorstellung des Inhabers:</ng-container>
                  &nbsp;
                  <app-price [amount]="context.config.price"/>
                </h2>
                <p>
                  <ng-container i18n>
                    Diese Domain wird vom Inhaber zum Verkauf angeboten (ohne Webseite).
                    Alle angegebenen Preise sind Endpreise.
                  </ng-container>
                  &nbsp;
                  <app-tax-note [type]="context.user.paynow.price_type"/>
                </p>
              </div>
            </div>
          }

          @if (context.user.paynow.public_phone) {
            <div class="ed-note">
              <app-icon>call</app-icon>
              <div class="ed-content">
                <h2>{{ context.user.paynow.public_phone }}</h2>
                <ng-container i18n>Telefonnummer des Inhabers</ng-container>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="cell l6">
        <app-contactform [context]="context"/>
      </div>
    </div>
  </div>
</div>

@if (context.config.template_data['individual-content--text']) {
  <div class="ed-content-block-section">
    <div class="container">
      <app-content-block
        [content]="{
        headline: context.config.template_data['individual-content--headline'],
        text: context.config.template_data['individual-content--text'],
      }"
      />
    </div>
  </div>
}

<footer class="e--g-theme-bright">
  <div class="container">
    <div class="ed-top">
      <h2 i18n>
        So kaufen Sie eine Domain direkt beim Inhaber
      </h2>

      <div class="ed-steps-frame">
        <div class="grid">
          <div class="cell m6 l3">
            <div class="ed-step">
              <div class="ed-step-number">1</div>
              <div class="ed-step-content">
                <div class="ed-step-content">
                  <h3 i18n>Wunschdomain gefunden</h3>
                  <p i18n>Sie bekunden Ihr Interesse und übermitteln Ihr Angebot an den Inhaber per Formular mit "Anfrage senden".</p>
                </div>
              </div>
            </div>
          </div>
          <div class="cell m6 l3">
            <div class="ed-step">
              <div class="ed-step-number">2</div>
              <div class="ed-step-content">
                <div class="ed-step-content">
                  <h3 i18n>Bezahlvorgang</h3>
                  <p i18n>Nach der Einigung bezahlen Sie einfach per Paypal oder Überweisung. Dazu erhalten Sie eine ordnungsgemäße Rechnung mit Kaufvertrag.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="cell m6 l3">
            <div class="ed-step">
              <div class="ed-step-number">3</div>
              <div class="ed-step-content">
                <div class="ed-step-content">
                  <h3 i18n>Transfer der Domain</h3>
                  <p i18n>Nach Zahlungseingang wird die Domain zu Ihren Provider per Transfer übertragen (via Auth-Code).</p>
                </div>
              </div>
            </div>
          </div>
          <div class="cell m6 l3">
            <div class="ed-step">
              <div class="ed-step-number">4</div>
              <div class="ed-step-content">
                <div class="ed-step-content">
                  <h3 i18n>Loslegen!</h3>
                  <p i18n>Ihre neue Domain können Sie für ein Projekt nutzen oder einfach auf Ihre bestehende Homepage weiterleiten!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr>
    <div class="ed-bottom">
      <app-i18n-selector type="bordered"/>
      <div class="ed-content">
        <p i18n>
          Die Domain {{ context.config.display_name }} wird auf diesem
          <a [href]="context.links.marketplace|userToken|safe" target="_blank">Domain Marktplatz</a>
          angeboten. Über dieses Formular kann entwerder ein Angebot zum Kauf der Domain abgeben oder der
          Verantwortliche direkt kontaktiert werden. Alle Anfragen werden durch die kostenlose Technologie zum
          <a [href]="context.links.promo_sell_domains|userToken|safe" target="_blank">Domains verkaufen</a>
          automatisiert an den Inhaber weitergeleitet.
        </p>
        <div class="ed-links">
          <div class="ed-copyright">
            © {{ year }} elitedomains.de
          </div>
          <div class="ed-separator"></div>
          <a [routerLink]="['/impressum']" rel="nofollow" class="ed-imprint" target="_blank" i18n>
            Impressum
          </a>
        </div>
      </div>
    </div>
  </div>
</footer>
